// extracted by mini-css-extract-plugin
module.exports = {"dropdown-item":"Item_dropdown-item__3IW8B","dropdown-item--selected":"Item_dropdown-item--selected__2Ltbu"};